<template>
	<div class="container">
		<div>
			<div :style="textStyle">
				<h5>Sélection de la watermark</h5>
			</div>
			<div class="m-0">
				<div class="ml-2">
					<flickity v-if="this.carouselImages.length > 0" :options="flickityOptions">
						<ul class="carousel-cell" v-for="(image, index) in this.carouselImages" :key="index">
							<div>
								<img :src="image.url" alt="Watermark" class="watermark-img" />
							</div>
							<div class="watermark-checkbox">
								<input class="checkbox_watermark"
									type="checkbox"
									v-model="image.checked"
									:id="index"
									:value="image"
									@click="setWatermark(image)"
									ref="checkboxWatermarks">
							</div>
						</ul>
					</flickity>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<ValidStep :id=this.projectId
					:imageArray="this.carouselImages.filter(step => step.checked === true)" />
			</div>
		</div>
	</div>
</template>

<script>
import Flickity from "vue-flickity";
import axios from "axios";
import ValidStep from "../ui/buttons/ValidStepWatermark";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	name: "Watermark",
	components: {Flickity, ValidStep},
	props: {
		id: Number,
		stepName: String,
		stepIndex: Number,
		isCompleted: Boolean,
		isVisible: Boolean,
		projectId: Number,
		renderId: String,
		watermarkId: Number,
	},
	data() {
		return {
			carouselImages: [],
			arrayCheck: [],
			flickityOptions: {
				initialIndex: 1,
				prevNextButtons: true,
				pageDots: true,
				wrapAround: false,
				draggable: false,
			},
			textStyle: {
				"color": process.env.VUE_APP_PRIMARY_COLOR,
				"marginTop": "3rem",
				"marginBottom": "20px",
			},
		};
	},
	activated() {
		this.getWatermarkImages();
	},
	methods: {
		getWatermarkImages() {
			this.carouselImages = [];
			let $this = this;
			axios.get(BASE_URL + "/public/api/watermarks", {
				headers: {
					"Authorization": sessionStorage.getItem("auth"),
				},
			})
			.then(response => {
				let data = response.data.data.watermarks;
				data.forEach(function (element) {
					if (element.id === Number($this.watermarkId)) {
						element.checked = "checked";
						element.id = $this.watermarkId;
					}
					$this.carouselImages.push(element);
				});
			}).catch(error => {
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});
		},
		next() {
			this.$refs.flickity.next();
		},
		previous() {
			this.$refs.flickity.previous();
		},
		setWatermark(image) {
			this.carouselImages.forEach(function (element) {
				if (image.id !== element.id) {
					element.checked = false;
				}
				else {
					element.checked = true;
				}
			});
		},
	},
};
</script>

<style scoped>
.carousel-cell {
	margin-left: 20px;
}

h5 {
	color: #004F9E;
}

.watermark-checkbox {
	text-align: center;
}

.watermark-img {
	border: 1px #004F9E solid;
	width: 350px;
	height: 100%;
	margin-left: 15px;
	margin-right: 10px;
}
</style>
